import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import { BModal, BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import { mapState } from 'vuex'

export default {
  name: 'noticias',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    'b-modal': BModal,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    tabelaSemRegistros () {
      return this.listaNoticias.length === 0
    }
  },

  data: () => {
    return {
      listaNoticias: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      retorno: {
        sucesso: false,
        mensagem: ''
      },
      idNoticia: null
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaNoticias()
  },

  methods: {
    async obterListaNoticias () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina
        }
        const resposta = await this.axios.post('/noticias', parametrosRequisicao)
        this.listaNoticias = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaNoticias()
    },

    detalhesNoticia (id) {
      this.$router.push({ name: 'detalhes-noticias', params: { id: id } })
    },

    editarNoticia (id) {
      this.$router.push({ name: 'edicao-noticias', params: { id: id } })
    },

    incluirNoticia () {
      this.$router.push({ name: 'cadastro-noticias' })
    },

    showModalExcluirNoticia (id) {
      this.idNoticia = id
      this.$bvModal.show('modalExcluir')
    },

    async excluirNoticia () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.axios.delete('/noticias/remover/' + this.idNoticia)
        this.definirFlagCarregandoDados(false, '')
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem

        if (this.retorno.sucesso) {
          util.criarAlertaToastDeSucesso(this, 'Aviso', this.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
        }
        this.componentePaginacao.pagina = 1
        this.obterListaNoticias()
      } catch (e) {
        this.definirFlagCarregandoDados(false, '')
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    }
  }
}
